<template>
  <div>
    <AlertComponent
      v-if="!detailActivity"
      :text="'Selecciona una actividad para poder identificar peligros y evaluar riesgos.'"
    />
    <div v-else>
      <div class="content-title-activity">
        <img
          src="@/assets/images/icons/icon-matriz-iper/icon-left.png"
          alt=""
        />
        <h1>{{ detailActivity?.name }}</h1>
      </div>
      <h2 class="subtitle-activity">Formato de Matríz IPER / Matríz vigente</h2>
      <hr class="hr-filter-info" />
      <b-overlay :show="isLoadingMatrizIper" rounded="sm">
        <template #overlay>
          <OverlayButton clase="overlay-md"> </OverlayButton>
        </template>
        <b-tabs
          v-model="tabIndex"
          class="tabs-section-form-calificacion-activity"
        >
          <div class="mt-5 text-left">
            <hr class="hr-form-ipt" />
            <b-tab>
              <template #title>Caracterización</template>
              <FormCaracterizacion
                :totalPropios="totalPropios"
                :isBusy="isBusy"
                :idMatrizIper="idMatrizIper"
                :record="formData"
                @saveData="saveCharacterization"
              />
            </b-tab>
            <b-tab :disabled="idMatrizIper ? false : true">
              <template #title>Sin mitigación</template>
              <FormNoMitigation
                :isBusy="isBusy"
                :dataKinney="dataKinney"
                :riskClassification="riskClassificationNoMitigation"
                :score="riskClassificationNoMitigationScore"
                :record="formData"
                @saveData="saveNoMitigation"
              />
            </b-tab>
            <b-tab :disabled="idMatrizIper ? false : true">
              <template #title>Controles</template>
              <FormControl
                :isBusy="isBusy"
                @saveData="saveControl"
                :record="formData"
              />
            </b-tab>
            <b-tab :disabled="idMatrizIper ? false : true">
              <template #title>Con mitigación</template>
              <FormWithMitigation
                :isBusy="isBusy"
                :dataKinney="dataKinney"
                :riskClassification="riskClassificationMitigation"
                :score="riskClassificationMitigationScore"
                :record="formData"
                @saveData="saveMitigation"
              />
            </b-tab>
            <b-tab :disabled="idMatrizIper ? false : true">
              <template #title>Registro Empleado</template>
              <FormEmployee
                :idMatrizIper="idMatrizIper"
                :record="formData"
                @saveDataSuccess="
                  (message) => $emit('saveDataSuccess', message)
                "
                @saveDataError="(message) => $emit('saveDataError', message)"
              />
            </b-tab>
            <div class="mt-5 d-flex justify-content-between">
              <button
                class="button_primary"
                :disabled="tabIndex <= 0 || isBusy"
                @click.prevent="previous"
              >
                Anterior
              </button>
              <button
                class="button_primary"
                @click.prevent="next"
                :disabled="
                  tabIndex == 3 || (idMatrizIper ? false : true) || isBusy
                "
              >
                Siguiente
              </button>
            </div>
          </div>
        </b-tabs>
      </b-overlay>
    </div>
    <ModalKinney :data="methodsKinney" :isLoading="isLoadingKinney" />
  </div>
</template>

<script>
import AlertComponent from "./AlertComponent.vue";
import OverlayButton from "@/components/core/overlay/overlay-button.vue";
import FormCaracterizacion from "./forms/FormCaracterization.vue";
import FormNoMitigation from "./forms/FormNoMitigation.vue";
import FormWithMitigation from "./forms/FormWithMitigation.vue";
import FormControl from "./forms/FormControl.vue";
import FormEmployee from "./forms/FormEmployee.vue";
import ModalKinney from "../../modals/ModalKinney.vue";
import {
  getKinney,
  saveIper,
  updateIper,
  getIper,
} from "@/services/health-tracker/matrizIper/service";
export default {
  components: {
    OverlayButton,
    AlertComponent,
    FormCaracterizacion,
    FormNoMitigation,
    FormWithMitigation,
    FormControl,
    FormEmployee,
    ModalKinney,
  },
  props: {
    detailActivity: {
      type: Object,
      default: null,
    },
    totalPropios: {
      type: Number,
      default: 0,
    },
    idArea: {
      type: Number,
      default: 0,
    },
    idPosition: {
      type: Number,
      default: 0,
    },
    risks: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      tabIndex: 0,
      loading: false,
      isLoadingKinney: false,
      formData: {
        // requerido
        area_id: "",
        position_id: "",
        danger_risk_id: "",
        contractors: null,
        activity_id: "",
        source_of_danger: "",
        // opcional
        with_mitigation: {
          probability: "",
          frequency: "",
          impact: "",
          risk_description: "",
        },

        source_control: "",
        environment_control: "",
        individual_control: "",

        without_mitigation: {
          probability: "",
          frequency: "",
          impact: "",
          risk_residual_description: "",
        },
      },
      isBusy: false,
      idMatrizIper: null,
      messageModal: "Caracterización guardada exitosamente",
      methodsKinney: {
        frequency: [],
        impact: [],
        probability: [],
      },
      dataKinney: {
        frequency: [],
        impact: [],
        probability: [],
      },
      riskClassificationMitigation: {
        id: 1,
        name: "Sin calificación",
        icon: require("@/assets/images/icons/icon-matriz-iper/sin-calification.png"),
        score: [0],
        text: "Sin registro de datos",
        background: "#ECEFF1",
        color: "#546E7A",
      },
      riskClassificationNoMitigation: {
        id: 1,
        name: "Sin calificación",
        icon: require("@/assets/images/icons/icon-matriz-iper/sin-calification.png"),
        score: [0],
        text: "Sin registro de datos",
        background: "#ECEFF1",
        color: "#546E7A",
      },
      riskClassificationMitigationScore: 0,
      riskClassificationNoMitigationScore: 0,
      isLoadingMatrizIper: false,
      abortController: null,
    };
  },
  watch: {
    detailActivity() {
      const me = this;
      me.resetFormData();
      if (me.detailActivity?.iper?.length > 0) {
        console.log("me.detailActivity", me.detailActivity);
        me.loadMatrizIper(me.detailActivity?.iper[0]?.id);
      } else {
        me.idMatrizIper = null;
        me.riskClassificationMitigation = {
          id: 1,
          name: "Sin calificación",
          icon: require("@/assets/images/icons/icon-matriz-iper/sin-calification.png"),
          score: [0],
          text: "Sin registro de datos",
          background: "#ECEFF1",
          color: "#546E7A",
        };
        me.riskClassificationNoMitigation = {
          id: 1,
          name: "Sin calificación",
          icon: require("@/assets/images/icons/icon-matriz-iper/sin-calification.png"),
          score: [0],
          text: "Sin registro de datos",
          background: "#ECEFF1",
          color: "#546E7A",
        };
        me.riskClassificationMitigationScore = 0;
        me.riskClassificationNoMitigationScore = 0;
      }
    },
  },
  methods: {
    previous() {
      const me = this;
      me.tabIndex = me.tabIndex - 1;
    },
    next() {
      const me = this;
      me.tabIndex = me.tabIndex + 1;
    },
    resetFormData() {
      const me = this;
      me.formData = {
        // requerido
        area_id: "",
        position_id: "",
        danger_risk_id: "",
        activity_id: "",
        contractors: null,
        source_of_danger: "",
        // opcional
        with_mitigation: {
          probability: "",
          frequency: "",
          impact: "",
          risk_description: "",
        },

        source_control: "",
        environment_control: "",
        individual_control: "",

        without_mitigation: {
          probability: "",
          frequency: "",
          impact: "",
          risk_residual_description: "",
        },
      };
    },
    saveCharacterization(formData) {
      const me = this;
      me.formData = {
        ...me.formData,
        ...formData,
      };
      me.messageModal = "Caracterización guardada exitosamente";
      me.saveData();
    },
    saveNoMitigation(formData) {
      const me = this;
      me.formData = {
        ...me.formData,
        ...formData,
      };
      me.messageModal = "Sin mitigación guardada exitosamente";
      me.saveData();
    },
    saveControl(formData) {
      const me = this;
      me.formData = {
        ...me.formData,
        ...formData,
      };
      me.messageModal = "Controles guardados exitosamente";
      me.saveData();
    },
    saveMitigation(formData) {
      const me = this;
      me.formData = {
        ...me.formData,
        ...formData,
      };
      me.messageModal = "Con mitigación guardada exitosamente";
      me.saveData();
    },
    async saveData() {
      const me = this;
      me.isBusy = true;
      const formData = {
        ...(me.formData.contractors && {
          contractors: me.formData.contractors,
        }),
        ...(me.formData.source_of_danger && {
          source_of_danger: me.formData.source_of_danger,
        }),
        ...(me.formData.danger_risk_id && {
          danger_risk_id: me.formData.danger_risk_id,
        }),
        ...(me.formData.with_mitigation.probability && {
          with_mitigation: {
            probability: me.formData.with_mitigation.probability,
            frequency: me.formData.with_mitigation.frequency,
            impact: me.formData.with_mitigation.impact,
            risk_description: me.formData.with_mitigation.risk_description,
          },
        }),
        ...(me.formData.without_mitigation.frequency && {
          without_mitigation: {
            frequency: me.formData.without_mitigation.frequency,
            impact: me.formData.without_mitigation.impact,
            probability: me.formData.without_mitigation.probability,
            risk_residual_description:
              me.formData.without_mitigation.risk_residual_description,
          },
        }),
        ...(me.formData.source_control && {
          source_control: me.formData.source_control,
        }),
        ...(me.formData.environment_control && {
          environment_control: me.formData.environment_control,
        }),
        ...(me.formData.individual_control && {
          individual_control: me.formData.individual_control,
        }),
        area_id: me.idArea,
        position_id: me.idPosition,
        activity_id: me.detailActivity.id,
      };
      try {
        const { data } = me.idMatrizIper
          ? await updateIper(formData, me.idMatrizIper)
          : await saveIper(formData);
        console.log(data);
        me.idMatrizIper = data?.id;
        if (data?.without_mitigation_score) {
          me.riskClassificationNoMitigationScore =
            data?.without_mitigation_score;
          me.riskClassificationNoMitigation = me.classificationRisk(
            data?.without_mitigation_score
          );
        }
        if (data?.mitigation_score) {
          me.riskClassificationMitigationScore = data?.mitigation_score;
          me.riskClassificationMitigation = me.classificationRisk(
            data?.mitigation_score
          );
        }
        me.$emit("saveDataSuccess", me.messageModal);
      } catch (error) {
        me.$emit("saveDataError", "Error al guardar Formulario");
      } finally {
        me.isBusy = false;
      }
    },
    async loadKinney() {
      const me = this;
      me.isLoadingKinney = true;
      try {
        const { data } = await getKinney();
        me.methodsKinney = {
          ...me.methodsKinney,
          ...data,
          risks: me.risks,
        };
        me.dataKinney.frequency = me.methodsKinney.frequency.map((item) => {
          return {
            id: item.id,
            name: item?.event?.action,
          };
        });
        me.dataKinney.impact = me.methodsKinney.impact.map((item) => {
          return {
            id: item.id,
            name: item?.event?.action,
          };
        });
        me.dataKinney.probability = me.methodsKinney.probability.map((item) => {
          return {
            id: item.id,
            name: item?.event?.action,
          };
        });
        me.dataKinney.risks = me.risks;
      } catch (error) {
        console.log(error);
      } finally {
        me.isLoadingKinney = false;
      }
    },
    async loadMatrizIper(id) {
      const me = this;
      me.isLoadingMatrizIper = true;
      if (me.abortController) {
        me.abortController.abort(); // Cancela la petición anterior
      }

      me.abortController = new AbortController();
      const signal = me.abortController.signal;
      try {
        const { data } = await getIper(id, signal);
        me.idMatrizIper = data?.id;
        if (data?.without_mitigation_score) {
          me.riskClassificationNoMitigationScore =
            data?.without_mitigation_score;
          me.riskClassificationNoMitigation = me.classificationRisk(
            data?.without_mitigation_score
          );
        }
        if (data?.mitigation_score) {
          me.riskClassificationMitigationScore = data?.mitigation_score;
          me.riskClassificationMitigation = me.classificationRisk(
            data?.mitigation_score
          );
        }
        me.formData = {
          // requerido
          area_id: data?.area_id,
          position_id: data?.position_id,
          danger_risk_id: data?.danger_risk_id,
          contractors: data?.contractors,
          activity_id: data?.activity_id,
          source_of_danger: data?.source_of_danger,
          // opcional
          with_mitigation: {
            probability: data?.with_mitigation?.probability,
            frequency: data?.with_mitigation?.frequency,
            impact: data?.with_mitigation?.impact,
            risk_description: data?.with_mitigation?.risk_description,
          },
          source_control: data?.source_control,
          environment_control: data?.environment_control,
          individual_control: data?.individual_control,
          without_mitigation: {
            probability: data?.without_mitigation?.probability,
            frequency: data?.without_mitigation?.frequency,
            impact: data?.without_mitigation?.impact,
            risk_residual_description:
              data?.without_mitigation?.risk_residual_description,
          },
          danger_risk: data?.danger_risk,
          user_id: data?.user_id,
          user_photo: data?.user_photo,
        };
      } catch (error) {
        console.log(error);
      } finally {
        me.isLoadingMatrizIper = false;
      }
    },
    classificationRisk(score) {
      const me = this;
      let risk = me.methodsKinney.risks.find((risk) => {
        // Si el score es un rango [min, max], verificar si el número está en ese rango
        if (risk.score.length === 2) {
          return score >= risk.score[0] && score <= risk.score[1];
        }
        // Si el score es un valor único
        return score <= risk.score[0];
      });
      return risk;
    },
  },
  mounted() {
    const me = this;
    me.loadKinney();
  },
};
</script>

<style lang="css">
.content-title-activity {
  display: flex;
  align-items: center;
}
.content-title-activity h1 {
  font-size: 21px !important;
  color: #37474f !important;
}
.subtitle-activity {
  color: #546e7a !important;
  font-size: 16px !important;
  line-height: 28px !important;
}

.button_primary {
  display: flex;
  align-items: center;
  background-color: #5d5fef;
  height: 40px;
  border-radius: 8px;
  font-size: 18px;
  gap: 10px;
  border: none;
  color: white;
  padding: 15px;
}

.content-risks-activity span {
  font-size: 14px;
  color: #263238;
  font-weight: 600;
}
</style>
